let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("90CLa")).then(() => parcelRequire('evT2J'));